// extracted by mini-css-extract-plugin
module.exports = {"centeringParent":"Container_centeringParent__hyRrh"};